import { Close } from '@mui/icons-material';
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import { useState } from 'react';
import { approveConsultantFacilityRequest } from '../../../../helpers/api';
import { openNotification } from '../../../../helpers/notification';

export default function ConsultantHandleRequest({ open, onClose, facilityId, consultant }) {
  const [saving, setSaving] = useState(false);

  const handleReject = async () => {
    setSaving(true);
    try {
      const payload = {
        approve: false,
        facilityId: facilityId,
        consultantId: consultant.consultantId,
      };
      const res = await approveConsultantFacilityRequest(payload);
      const { data, status } = res?.result;
      if (status?.code === '00') {
        openNotification({ type: 'success', message: status?.desc });
        onClose();
      } else {
        openNotification({ type: 'error', message: status?.desc });
      }
    } catch (error) {
      console.log(error);
      const errmsg = error?.data?.result?.status?.desc;
      openNotification({ type: 'error', message: errmsg });
    } finally {
      setSaving(false);
    }
  };

  const handleApprove = async () => {
    setSaving(true);
    try {
      const payload = {
        approve: true,
        facilityId: facilityId,
        consultantId: consultant.consultantId,
      };
      const res = await approveConsultantFacilityRequest(payload);
      const { data, status } = res?.result;
      if (status?.code === '00') {
        openNotification({ type: 'success', message: status?.desc });
        onClose();
      } else {
        openNotification({ type: 'error', message: status?.desc });
      }
    } catch (error) {
      console.log(error);
      const errmsg = error?.data?.result?.status?.desc;
      openNotification({ type: 'error', message: errmsg });
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <DialogTitle variant="body1" sx={{ fontWeight: 600 }}>
          Handle Request
        </DialogTitle>
        <Box ml="auto" px={3}>
          <IconButton onClick={() => onClose()} disabled={saving}>
            <Close />
          </IconButton>
        </Box>
      </Box>
      <DialogContent>
        <Alert severity="info" icon={false}>
          {`Request to join facility`}
        </Alert>
        <br />
        <Typography variant="body2">{`${consultant?.consultantName} requested to be a consultant for your facility.`}</Typography>
      </DialogContent>
      <DialogActions sx={{ px: 2, pb: 2 }}>
        <Button
          type="button"
          variant="contained"
          color="error"
          disabled={saving}
          startIcon={saving && <CircularProgress size={20} />}
          onClick={handleReject}
          sx={{ textTransform: 'none', borderRadius: 20 }}
        >
          Decline
        </Button>
        <Button
          type="button"
          variant="contained"
          color="info"
          disabled={saving}
          startIcon={saving && <CircularProgress size={20} />}
          onClick={handleApprove}
          sx={{ textTransform: 'none', borderRadius: 20 }}
        >
          Approve
        </Button>
      </DialogActions>
    </Dialog>
  );
}
